import { styled } from '@mui/system';
import { FC, ReactNode } from 'react';
import { Page } from './Page';

type TPageHelmet = {
  title: string,
  children: ReactNode
};

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const PageHelmet: FC<TPageHelmet> = ({ title, children }) => (
  <RootStyle title={title}>
    {children}
  </RootStyle>
);

export {
  PageHelmet,
};
